import React from 'react';
import { useGetBase64Image } from '../hooks/UseGetBase64Image';

interface Props {
  src: string
  alt?: string
  style?: React.CSSProperties
}

const Img = ({ src, alt, style }: Props) => {
  const base64Image = useGetBase64Image(src);

  return (
    <img src={base64Image} alt={alt} style={style} />
  );
};

export default Img;
